module.exports = __webpack_public_path__ + "img/62131248000491.dfc08b47.png";